require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-object-oriented-programming.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-object-oriented-programming");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-object-oriented-programming!./.cache/json/javascript-algorithms-and-data-structures-object-oriented-programming.json
// module id = 2449
// module chunks = 231608221292675